module.exports = __webpack_public_path__ + "assets/img/img_2018.b7c9f619.jpg";